(() => {
  const initPagination = () => {
    if (window.Eurus.paginationInitialized) return;
    window.Eurus.paginationInitialized = true;
    window.Eurus.loadedScript.add('pagination.js');
    Alpine.data('xPagination', (sectionId) => ({
      loading: false,
      error: false,
      loadedUrls: [],
      controller: null,
      destroy() { this.controller?.abort(); },
      async loadData(url) {
        if (this.loading || this.loadedUrls.includes(url)) return false;
        this.loading = true;
        this.error = false;
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, {signal: controller.signal});
          if (!response.ok) throw new Error(`Pagination HTTP ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (controller.signal.aborted) return false;
          const sourceGrid = html.getElementById('items-grid') || html.getElementById('blog-grid');
          const destinationGrid = document.getElementById('blog-grid') || document.getElementById('items-grid');
          const destinationButton = document.getElementById('btn-pagination-' + sectionId);
          const sourceButton = html.getElementById('btn-pagination-' + sectionId);
          if (!sourceGrid || !destinationGrid || !destinationButton || !sourceButton) {
            throw new Error('Missing pagination section');
          }
          // Commit a page in one insertion, without delayed writes or duplicate requests.
          const cards = Array.from(sourceGrid.getElementsByClassName('grid-item'));
          destinationGrid.insertAdjacentHTML('beforeend', cards.map(card => card.innerHTML).join(''));
          this.loadedUrls.push(url);
          destinationButton.innerHTML = sourceButton.innerHTML;
          return true;
        } catch (error) {
          this.error = true;
          return false;
        } finally {
          clearTimeout(timeout);
          this.loading = false;
          this.controller = null;
        }
      }
    }));
  };
  if (window.Alpine) initPagination();
  else document.addEventListener('alpine:init', initPagination, {once: true});
})();
